module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/878ad516d69f16d84a951159960d4ca5.png";